export function getImageUrl(src = ''): string {
  return src;
}
